module.exports = __webpack_public_path__ + "tea_mockup_design_josif_pancic_cajevi_sipak_red_cynosbati_fructus.jpg?1f63ff0adce2f0cc4c54e556812a9746";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/josif_pancic/tea_mockup_design_josif_pancic_cajevi_sipak_red_cynosbati_fructus.jpg
// module id = 86
// module chunks = 0